//3rd Party Components
import React, { Fragment } from 'react';
import TagManager from 'react-gtm-module'
import { useEffect } from 'react';
import { useSelector } from "react-redux";
import moment from 'moment';

//Components
import HeaderContent from "./HeaderContent";

//Actions and Selectors

//Actions and Selectors
import { getSystemSelector, getFeatureSelector, getUrlSelector } from '../../PortalStore/Selectors/EnvDataSelectors';

const Header = () => {
    let gtag = useSelector(state => getSystemSelector(state, "Portal - Google GA Code"));
    const tagManagerArgs = {
        gtmId: gtag
    }

    let vaurl = useSelector(state => getUrlSelector(state, "Portal - Virtual Assistant URL"));
    let vaavail = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - Virtual Assistant"));
    const isFeatureVA = vaavail ? moment().isSameOrAfter(moment(vaavail, 'DD/MM/YYYY')) : false;

    useEffect(() => {
        if (gtag !== undefined) {
            TagManager.initialize(tagManagerArgs);
        }

        if (isFeatureVA) {
            const script = document.createElement('script');

            script.src = vaurl;
            script.async = true;
            script.id = 'va';

            document.body.appendChild(script);
        }

        return () => {
            if (isFeatureVA) {
                document.body.removeChild(document.getElementById('va'));
            }
        }

    }, []);

    return (

        <Fragment>

            <a className="au-skip-link__link" href="#maincontent" id="skipper">Skip to main content</a>

            <HeaderContent />

        </Fragment>

    )

}

export default Header;

